var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 166C134.899 166 164 136.899 164 101C164 65.1015 134.899 36 99 36C63.1015 36 34 65.1015 34 101C34 136.899 63.1015 166 99 166Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1667 152.333C126.425 152.333 149.333 129.425 149.333 101.167C149.333 72.9081 126.425 50 98.1667 50C69.9081 50 47 72.9081 47 101.167C47 129.425 69.9081 152.333 98.1667 152.333Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1501 83.1774V97.2574C92.1501 98.7974 90.8968 100.051 89.3568 100.051H75.2767C73.7367 100.051 72.4834 101.304 72.4834 102.844V109.057C72.4834 110.597 73.7367 111.851 75.2767 111.851H89.3568C90.8968 111.851 92.1501 113.104 92.1501 114.644V128.724C92.1501 130.264 93.4034 131.517 94.9434 131.517H101.157C102.697 131.517 103.95 130.264 103.95 128.724V114.644C103.95 113.104 105.203 111.851 106.743 111.851H120.823C122.363 111.851 123.617 110.597 123.617 109.057V102.844C123.617 101.304 122.363 100.051 120.823 100.051H106.743C105.203 100.051 103.95 98.7974 103.95 97.2574V83.1774C103.95 81.6374 102.697 80.384 101.157 80.384H94.9434C93.4034 80.384 92.1501 81.6374 92.1501 83.1774Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6667 76.7933V90.8733C89.6667 92.4133 88.4134 93.6667 86.8734 93.6667H72.7933C71.2533 93.6667 70 94.92 70 96.46V102.673C70 104.213 71.2533 105.467 72.7933 105.467H86.8734C88.4134 105.467 89.6667 106.72 89.6667 108.26V122.34C89.6667 123.88 90.92 125.133 92.46 125.133H98.6733C100.213 125.133 101.467 123.88 101.467 122.34V108.26C101.467 106.72 102.72 105.467 104.26 105.467H118.34C119.88 105.467 121.133 104.213 121.133 102.673V96.46C121.133 94.92 119.88 93.6667 118.34 93.6667H104.26C102.72 93.6667 101.467 92.4133 101.467 90.8733V76.7933C101.467 75.2533 100.213 74 98.6733 74H92.46C90.92 74 89.6667 75.2533 89.6667 76.7933Z",
    fill: "#FF5000",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTAdd);
export default __webpack_public_path__ + "static/media/TAdd.116db52817ce22d935b1f0089f065aaa.svg";
export { ForwardRef as ReactComponent };